"use client";

import { useState, useEffect } from "react";
import Link from "next/link";

export default function CookiePage() {
  const [cookieValue, setCookieValue] = useState<string | null>(null);
  const [redirectApp, setRedirectApp] = useState<string>("sessionCookie");
  const [apiResult, setApiResult] = useState<string>("");

  const refreshCookie = () => {
    const value = document.cookie
      .split("; ")
      .find((row) => row.startsWith("lbf_sso_session_id="))
      ?.split("=")[1];
    setCookieValue(value || null);
  };



  useEffect(() => {
    refreshCookie();
  }, []);

  const handleClearCookie = () => {
    document.cookie = "lbf_sso_session_id=; path=/; max-age=0";
    refreshCookie();
  };

  const handleCreateDummyCookie = () => {
    // Generate a UUID-like dummy session ID
    const dummySessionId = "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx".replace(/x/g, () =>
      ((Math.random() * 16) | 0).toString(16)
    );
    document.cookie = `lbf_sso_session_id=${dummySessionId}; path=/; max-age=3600`;
    refreshCookie();
  };

  const handleSSOLogin = async () => {
    setApiResult("Loading...");
    try {
      const response = await fetch(`/api/sso-login?redirectApp=${encodeURIComponent(redirectApp)}`);
      const data = await response.text();
      setApiResult(data);
      refreshCookie();
    } catch (error) {
      setApiResult(`Error: ${error}`);
    }
  };

  const handleValidateSession = async () => {
    setApiResult("Loading...");
    try {
      const response = await fetch('/api/validate-session');
      const data = await response.text();
      setApiResult(data);
    } catch (error) {
      setApiResult(`Error: ${error}`);
    }
  };

  const handleSessionCookie = async () => {
    setApiResult("Loading...");
    try {
      const response = await fetch('/api/session-cookie');
      const data = await response.text();
      setApiResult(data);
    } catch (error) {
      setApiResult(`Error: ${error}`);
    }
  };

  return (
    <main style={{ padding: 24, fontFamily: "system-ui" }}>
      <h1>Cookie Manager</h1>

      <div style={{ marginTop: 24 }}>
        <h2>lbf_sso_session_id Cookie</h2>
        <div
          style={{
            padding: 16,
            background: "#f5f5f5",
            borderRadius: 8,
            marginTop: 12,
            marginBottom: 12,
          }}
        >
          <strong>Current Value:</strong>
          <pre style={{ marginTop: 8, wordBreak: "break-all" }}>
            {cookieValue || "(not set)"}
          </pre>
        </div>

        <div style={{ display: "flex", gap: 12 }}>
          <button
            onClick={handleCreateDummyCookie}
            style={{
              padding: "8px 16px",
              background: "#0070f3",
              color: "white",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Create Dummy Value
          </button>
          <button
            onClick={handleClearCookie}
            style={{
              padding: "8px 16px",
              background: "#dc2626",
              color: "white",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Clear Cookie
          </button>
        </div>

        <div style={{ marginTop: 24 }}>
          <h2>SSO Login</h2>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: "block", marginBottom: 8 }}>
              <strong>Redirect App:</strong>
            </label>
            <input
              type="text"
              value={redirectApp}
              onChange={(e) => setRedirectApp(e.target.value)}
              style={{
                padding: "8px 12px",
                border: "1px solid #ccc",
                borderRadius: 4,
                width: "300px",
                fontFamily: "monospace",
              }}
            />
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            <button
              onClick={handleSSOLogin}
              style={{
                padding: "8px 16px",
                background: "#10b981",
                color: "white",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              Call SSO Login
            </button>
            <button
              onClick={handleValidateSession}
              style={{
                padding: "8px 16px",
                background: "#8b5cf6",
                color: "white",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              Validate Session
            </button>
            <button
              onClick={handleSessionCookie}
              style={{
                padding: "8px 16px",
                background: "#f59e0b",
                color: "white",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              Session Cookie
            </button>
          </div>

          <div style={{ marginTop: 24 }}>
            <label style={{ display: "block", marginBottom: 8 }}>
              <strong>API Response:</strong>
            </label>
            <textarea
              value={apiResult}
              readOnly
              style={{
                width: "100%",
                minHeight: "200px",
                padding: "12px",
                fontFamily: "monospace",
                fontSize: "12px",
                border: "1px solid #ccc",
                borderRadius: 4,
                background: "#f9f9f9",
                resize: "vertical",
              }}
              rows={8}
            />
          </div>
        </div>
      </div>
    </main>
  );
}
